export default {
    banners: {
        type: ["array"],
        default: () => []
    },
    banners1: {
        type: ["array"],
        default: () => []
    },
    banners2: {
        type: ["array"],
        default: () => []
    },
    banners3: {
        type: ["array"],
        default: () => []
    },
    banner1: {
        type: ["array"],
        default: () => []
    },
    banner2: {
        type: ["array"],
        default: () => []
    },
    banner3: {
        type: ["array"],
        default: () => []
    },
    suggest_banners: {
        type: ["array"],
        default: () => []
    }
};